'use client'
import cl from 'clsx'
import 'keen-slider/keen-slider.min.css'
import {useKeenSlider} from 'keen-slider/react'
import Button from '@/ui/button'
import {useState} from 'react'
import PaTool from './pa-tool'
import SaTool from './sa-tool'
import LcaTool from './lca-tool'
import styles from './styles.module.css'

export default function Discover ({dict}) {
    const [number, setNumber] = useState(1)
    const [descrtiption, setDescription] = useState(1)

    const selectDescription = (index) => {
        setDescription(index)
    }

    const [sliderRef, instanceRef] = useKeenSlider({
        slidesPerView: 1,
        mode: 'snap',
    })

    const prevSlide = () => {
        if (instanceRef) instanceRef.current?.prev();
        if (number > 1 ) {
            setNumber(number - 1)
        }
    };

    const nextSlide = () => {
        if (instanceRef) instanceRef.current?.next();
        if (number < 3) {
            setNumber(number + 1)
        }
    };
    
    let tool
    switch(number) {
        case 1: 
            tool = <PaTool descriptionNumber={descrtiption} select={selectDescription } dict={dict} />
            break
        case 2:
            tool = <SaTool descriptionNumber={descrtiption} select={selectDescription } dict={dict} />
            break
        case 3:
            tool = <LcaTool descriptionNumber={descrtiption} select={selectDescription } dict={dict}/>
            break
        default: 
            tool = <PaTool descrtiptionNumber={descrtiption} select={selectDescription } dict={dict}/>
    }

    const {tool_1, tool_2, tool_3, discover_more} = dict.discover;
    return (
        <div id={'discover'} className={styles.discover}>
            <div className={styles.discover__image_block}>
                <div id='discover-target' ref={sliderRef} className={cl(styles.discover__slider, 'keen-slider')}>
                    <div className={cl(styles.discover__slide_1, "keen-slider__slide")}>
                        <div className={styles.discover__slide_content}>
                            <div className={styles.discover__slide_number}>/ 01</div>
                            <div className={styles.discover__slide_title}>{tool_1}</div>
                        </div>
                    </div>
                    <div className={cl(styles.discover__slide_2, "keen-slider__slide")}>
                        <div className={styles.discover__slide_content}>
                            <div className={styles.discover__slide_number}>/ 02</div>
                            <div className={styles.discover__slide_title}>{tool_2}</div>
                        </div>
                    </div>
                    <div className={cl(styles.discover__slide_3, "keen-slider__slide")}>
                        <div className={styles.discover__slide_content}>
                            <div className={styles.discover__slide_number}>/ 03</div>
                            <div className={styles.discover__slide_title}>{tool_3}</div>
                        </div>
                    </div>
                </div>

                <div className={styles.discover__image_block_title_content}>
                    <div className={styles.discover__image_block_title}>
                        <span className={styles.discover__image_block_title_content_number}>
                            0{number} /  <span className={styles.discover__image_block_title_content_number_second}>03</span>
                        </span>
                        {discover_more}
                    </div>
                    <div className={styles.discover__button_wrapper}>
                        <Button onClick={prevSlide} type="round-left" section="discover" />
                        <Button onClick={nextSlide} type="round-right" section="discover" />
                    </div>
                </div>
            </div>

            <div className={styles.discover__text_block}>
                {tool}
            </div>
        </div>
    );
}